<template>
  <div>
    <h5 class="title" style="">
      {{ lodash.upperCase($t('Filter')) }}
    </h5>
    <b-card no-body class="border-0">
      <b-card-body style="" ref="filterWrapper" class="relative filter-wrapper">
        <div class="d-flex gap-3 align-items-start">
          <template  v-for="(column, key) in filterColumns">
            <div :key="key + '1'" class="g-2 mb-3" v-bind="column.wrapperProps">
              <div :style="`width: 10rem; ${column.style}`">
                <div class="label-filter" style="margin-bottom: 5px">{{lodash.startCase(column.label)}}</div>
                <component v-if="column.input_component" v-bind:is="column.input_component" v-model="column.value" placeholder="-"></component>
                <b-input v-else
                    :value="column.value" @update="$set(column, 'value', $event)" :debounce="500" />
              </div>
            </div>
          </template>
          <b-input style="visibility: hidden;"></b-input>
        </div>
        <div class="right-arrow-control" ref="rightArrowControl" role="button" @click="scrollFilter(scrollFactor)">
          <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.277136 14.7036C0.0923787 14.5059 0 14.2719 0 14.0016C0 13.7318 0.0923787 13.498 0.277136 13.3004L5.69053 7.50988L0.25866 1.6996C0.0862201 1.51515 0 1.28458 0 1.00791C0 0.731225 0.0923787 0.494071 0.277136 0.296443C0.461894 0.0988142 0.680647 0 0.933395 0C1.18565 0 1.40416 0.0988142 1.58891 0.296443L7.79677 6.95652C7.87067 7.03557 7.92314 7.12121 7.95418 7.21344C7.98473 7.30567 8 7.40448 8 7.50988C8 7.61528 7.98473 7.7141 7.95418 7.80632C7.92314 7.89855 7.87067 7.98419 7.79677 8.06324L1.57044 14.7233C1.398 14.9078 1.18565 15 0.933395 15C0.680647 15 0.461894 14.9012 0.277136 14.7036Z"
              fill="white" />
          </svg>
        </div>
        <div class="left-arrow-control d-none" ref="leftArrowControl" role="button" @click="scrollFilter(-scrollFactor)">
          <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.72286 14.7036C7.90762 14.5059 8 14.2719 8 14.0016C8 13.7318 7.90762 13.498 7.72286 13.3004L2.30947 7.50988L7.74134 1.6996C7.91378 1.51515 8 1.28458 8 1.00791C8 0.731225 7.90762 0.494071 7.72286 0.296443C7.5381 0.0988142 7.31935 0 7.0666 0C6.81435 0 6.59584 0.0988142 6.41109 0.296443L0.20323 6.95652C0.12933 7.03557 0.07686 7.12121 0.04582 7.21344C0.01527 7.30567 0 7.40448 0 7.50988C0 7.61528 0.01527 7.7141 0.04582 7.80632C0.07686 7.89855 0.12933 7.98419 0.20323 8.06324L6.42956 14.7233C6.602 14.9078 6.81435 15 7.0666 15C7.31935 15 7.5381 14.9012 7.72286 14.7036Z"
              fill="white" />
          </svg>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import CustomerTypeSelect from "@/components/inputs/filter/customer-type-select"
import Datepicker from "@/components/inputs/datepicker"
import DatepickerRange from "@/components/inputs/filter/datepicker-range"
import DeliveryOrderMultiselectAjax from "@/components/inputs/filter/delivery-order-multiselect-ajax"
import DriverMultiselectAjax from "@/components/inputs/filter/driver-multiselect-ajax"
import FactoryMultiselectAjax from "@/components/inputs/filter/factory-multiselect-ajax"
import LocalMarketSaleOrderMultiselectAjax from "@/components/inputs/filter/local-market-sale-order-multiselect-ajax"
import LcsMultiselectAjax from "@/components/inputs/filter/lcs-multiselect-ajax"
import NumberRange from "@/components/inputs/filter/number-range"
import ProductServiceMultiselectAjax from "@/components/inputs/filter/product-service-multiselect-ajax"
import PurchaseOrderMultiselectAjax from "@/components/inputs/filter/purchase-order-multiselect-ajax"
import RangePrice from "@/components/inputs/range-price"
import SaleOrderMultiselectAjax from "@/components/inputs/filter/sale-order-multiselect-ajax"
import SaleOrderTypeSelect from "@/components/inputs/filter/sale-order-type-select"
import SupplierMultiselectAjax from "@/components/inputs/filter/supplier-multiselect-ajax"
import TicketMultiselectAjax from "@/components/inputs/filter/ticket-multiselect-ajax"
import TicketStatusSelect from "@/components/inputs/filter/ticket-status-select"
import TripMultiselectAjax from "@/components/inputs/filter/trip-multiselect-ajax"
import UserSelectAjax from "@/components/inputs/filter/user-select-ajax"
import VehicleMultiselectAjax from "@/components/inputs/filter/vehicle-multiselect-ajax"
import PurchaseOrderPaymentStatusSelect from "@/components/inputs/filter/purchase-order-payment-status-select"
import PurchasePaymentStatusSelect from "@/components/inputs/filter/purchase-payment-status-select"
import SalesInvoicePaymentStatusSelect from "@/components/inputs/filter/sales-invoice-payment-status-select"
import SalesReportPaymentStatusSelect from "@/components/inputs/filter/sales-report-payment-status-select"
import CustomerRoleSelect from "@/components/inputs/filter/customer-role-select"
import SalesPlanStatusSelect from "@/components/inputs/filter/sales-plan-status-select"
import PartnerCustomerMultiselectAjax from "@/components/inputs/filter/partner-customer-multiselect-ajax.vue";
import ProcessingCustomerMultiselectAjax from "@/components/inputs/filter/processing-customer-multiselect-ajax.vue";

export default {
  name: "model-filter",
  components: {
    CustomerTypeSelect,
    DatepickerRange,
    Datepicker,
    DeliveryOrderMultiselectAjax,
    DriverMultiselectAjax,
    FactoryMultiselectAjax,
    LcsMultiselectAjax,
    LocalMarketSaleOrderMultiselectAjax,
    NumberRange,
    ProductServiceMultiselectAjax,
    PurchaseOrderMultiselectAjax,
    RangePrice,
    SaleOrderMultiselectAjax,
    SaleOrderTypeSelect,
    SupplierMultiselectAjax,
    TicketMultiselectAjax,
    TicketStatusSelect,
    TripMultiselectAjax,
    UserSelectAjax,
    VehicleMultiselectAjax,
    PartnerCustomerMultiselectAjax,
    PurchaseOrderPaymentStatusSelect,
    PurchasePaymentStatusSelect,
    ProcessingCustomerMultiselectAjax,
    SalesInvoicePaymentStatusSelect,
    SalesReportPaymentStatusSelect,
    CustomerRoleSelect,
    SalesPlanStatusSelect,
  },
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    columns: {
      type: Object,
      default() {
        return {
          name: {
            label: this.$t('Name'),
            type: String
          }
        }
      }
    },
    modelVariable: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      filterColumns: Object.keys(this.value || {}).map((key) => {
        return({
          key: key.split('__').shift(),
          operator:  key.includes('__') ? key.split('__').pop() : this.columns?.[key]?.operator || undefined,
          value: (key.includes('__') ? key.split('__').pop() : undefined) === 'in' ? this.value[key].split(',') : this.value[key],
          input_component: this.columns[key.split('__').shift()].input_component,
          label: this.columns[key.split('__').shift()].label,
          style: this.columns[key.split('__').shift()].style,
          wrapperProps: this.columns[key.split('__').shift()].wrapperProps,
        })
      }),
      valueWatch: true,
      filterColumnsWatch: true,
      scrollFactor: 444,
    }
  },
  computed: {
    options() {
      if (this.modelVariable === 'ticket') {
        return [
          { value: '', text: this.$t("No Filter") },
          { value: 'contains', text: this.$t("Include") }
        ]
      } else {
        return [
          { value: '', text: this.$t('No Filter') },
          { value: 'begins_with', text: this.$t('Begins With') },
          { value: 'contains', text: this.$t('Contains') },
          { value: 'ends_with', text: this.$t('Ends With') },
          { value: 'eq', text: this.$t('Match Exactly') },
        ]
      }
    }
  },
  watch: {
    value() {
      if (!this.valueWatch) return;
      this.filterColumnsWatch = false;
      this.filterColumns = Object.keys(this.value || {}).map((key) => ({
        key: key.split('__').shift(),
        operator: key.includes('__') ? key.split('__').pop() : undefined,
        value: this.value[key],
        input_component: this.columns[key.split('__').shift()].input_component,
        label: this.columns[key.split('__').shift()].label,
        style: this.columns[key.split('__').shift()].style,
        wrapperProps: this.columns[key.split('__').shift()].wrapperProps,
      }));
      this.$nextTick(() => {
        this.filterColumnsWatch = true;
      })
    },
    filterColumns: {
      handler(vals) {
        this.valueWatch = false;
        let value = {};
        (vals || []).forEach((val) => {
          value[[val.key, ...(val.operator ? [val.operator] : [])].join('__')] = val.input_component
          if (Array.isArray(val.value)) {
            if (!val.value.length) {
              value[[val.key, ...(val.operator ? [val.operator] : [])].join('__')] = undefined
            } else {
              value[[val.key, ...(val.operator ? [val.operator] : [])].join('__')] = val.value.join(',')
            }
          } else {
            if (!val.value) {
              value[[val.key, ...(val.operator ? [val.operator] : [])].join('__')] = undefined
            } else {
              value[[val.key, ...(val.operator ? [val.operator] : [])].join('__')] = val.value
            }
          }

        })
        this.$emit('change', value)
        this.$nextTick(() => {
          this.valueWatch = true;
        })
      },
      deep: true,
    }
  },
  created() {
  },
  mounted() {
    // filterwrapper is x scrollable
    this.$refs.filterWrapper.addEventListener('scroll', (event) => {
      if (event.target.scrollLeft === 0) {
        this.$refs.leftArrowControl.classList.add('d-none')
      } else {
        this.$refs.leftArrowControl.classList.remove('d-none')
      }
      if (event.target.scrollLeft === event.target.scrollWidth - event.target.clientWidth) {
        this.$refs.rightArrowControl.classList.add('d-none')
      } else {
        this.$refs.rightArrowControl.classList.remove('d-none')
      }
    })

    window.addEventListener('resize', this.scrollableDisplayHandler)
    this.scrollableDisplayHandler();
  },
  methods: {
    scrollableDisplayHandler(){
      const hasScrollableContent = this.$refs.filterWrapper.scrollWidth > this.$refs.filterWrapper.clientWidth;
     if(hasScrollableContent){
      this.$refs.rightArrowControl.classList.remove('d-none')
    }else{
       this.$refs.rightArrowControl.classList.add('d-none')
     }
    },
    addFilter() {
      this.filterColumns.push({})
    },
    removeFilter(index) {
      this.filterColumns.splice(index, 1)
    },
    onKeyChange(column, event) {
      this.$set(column, 'key', event)
      this.$set(column, 'operator', this.columns[event].operator)
      this.$set(column, 'input_component', this.columns[event].input_component)
      this.$delete(column, 'value')
    },
    scrollFilter(x) {
      this.$refs.filterWrapper.scrollLeft += x
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-weight: 800;
  font-size: 14px !important;
  color: #6C7589 !important;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.filter-wrapper {
  scroll-behavior: smooth;
  overflow-x:auto;
  overflow-y: hidden;
  padding-inline: 32px;
  padding-bottom: 350px;
  margin-bottom: -350px;
  height: 460px;
  &::-webkit-scrollbar{
    display: none;
  }
}
// .dropdown-menu {
//   max-height: 200px;
//   overflow-y: auto;
// }
.right-arrow-control {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background: #ACACAC;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.left-arrow-control {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: #ACACAC;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.label-filter {
  font-weight: 500;
  font-size: 14px;
  color: #6C7589;
}

::v-deep {
  .multiselect__content-wrapper {
    position: static;
    max-height: 200px;
    overflow-y: auto;
  }
  .multiselect__tags,.custom-select {
    padding: 0.8rem 1rem !important;
  }
  .multiselect__select {
    height: 40px;
  }

  .custom-select {
    height: 45px;
  }

  .form-control {
    height: 44px;
  }

}
</style>
